import { useEffect, useState } from 'react';
import { mediaQurey } from 'helper/Style';
import OperationFilter from 'component/part/OperationFilter';

export type ModalProps = Readonly<{
  children: React.JSX.Element | React.JSX.Element[];
  display: boolean;
  className?: string;
  onHide?: () => void | Promise<void>;
}>;

export const modalStyle = {
  buttonArea: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap' as const,
    gap: '2rem',
    marginTop: '1.6rem',
    [mediaQurey('max', 'tablet')]: {
      flexDirection: 'column' as const,
      ['& > button']: {
        flex: '1',
      },
    },
  },
};

const style = {
  position: 'fixed' as const,
  left: '50%',
  top: '50%',
  transform: 'translateX(-50%) translateY(-50%)',
  padding: '2rem',
  backgroundColor: '#ffffff',
  border: 'solid 0.1rem #ccc',
  borderRadius: '1rem',
  boxShadow: '0 0.2rem 0.4rem #00000088',
};

const Modal = (props: ModalProps) => {
  const [display, setDisplay] = useState(props.display);

  const onHide = () => {
    props.onHide ? props.onHide() : setDisplay(false);
  };

  useEffect(() => {
    setDisplay(props.display);
  }, [props.display]);

  return <OperationFilter display={display} onHide={onHide}>
    <div
      onClick={(event) => event.stopPropagation()}
      css={style}
      className={props.className}
    >
      {props.children}
    </div>
  </OperationFilter>;
};

export default Modal;
